import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <section className="py-8 bg-primary">
        <div className="container my-lg-3">
          <div className="row justify-content-center text-center">
            <div className="col-md-10 col-12">
              <h2 className="display-5 mb-3 text-white lh-1">
                Financial services are powerful tools to help reduce poverty
              </h2>
              <p className="lead px-lg-8 mb-2 text-white lh-sm">
                MicrofinanceBazar offers specialized business loan schemes aimed
                at empowering rural women entrepreneurs in disadvantaged areas
                of India.
              </p>
              <p className="lead text-light opacity-75 px-lg-8 lh-sm fw-normal">
                Our financial solutions for women entrepreneurs are designed to
                not only assist with funding but also to uplift their
                socio-economic status by ensuring access to credit and
                supporting business ventures.
              </p>
              <div className="d-flex justify-content-center">
                <div className="mt-1">
                  <a
                    class="btn btn-outline-light px-5 btn-md mt-3 mb-lg-0 mb-5 me-1"
                    href="/introduction"
                  >
                    Join Microfinance Bazar
                  </a>
                  <a
                    class="btn btn-dark px-5 btn-md mt-3 mb-lg-0 mb-5"
                    href="/introduction"
                  >
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="pt-7 pb-3">
        <div class="container">
          <div class="row justify-content-center text-center align-items-center">
            <div class="col-lg-8 co-md-10 col-12 px-0">
              <div class="mb-4">
                <Link to="/">
                  <img
                    src="./assets/images/logo.png"
                    width="130"
                    class="mb-4 logo-inverse"
                  />
                </Link>
                <p class="lead lh-sm fs-4 fw-normal">
                  MicrofinanceBazar refers to digital Fintech intermediary
                  providing financial services like loans, savings, and
                  insurance to low-income individuals or groups who do not have
                  access to traditional banking services. It helps people start
                  or expand small businesses, improve their living standards,
                  and break the cycle of poverty.
                </p>
              </div>
              <div>
                <h3 class="fw-bold mb-1">Connect with Our Team</h3>
                <p className="m-0 fs-5">MicrofinanceBazar</p>
                <p class="lh-sm">
                  <a href="mailto: info@Microfinancebazar.in" className="fs-4">
                    info@microfinancebazar.in
                  </a>
                  <br />
                  <a href="tel: +919471491032" class="text-dark fw-semibold">
                    (+91) 1800012345
                  </a>
                </p>
              </div>
            </div>
          </div>

          <hr class="mt-6 mb-3" />
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-6 col-12">
              <span>
                © <span id="copyright4">2025</span> MicrofinanceBazar
              </span>
            </div>

            <div class="col-lg-6 col-md-12 col-12 d-lg-flex justify-content-center">
              <nav class="nav nav-footer mb-lg-0 mb-1">
                <Link to="/disclaimer" class="nav-link ps-0" href="#">
                  Disclaimer
                </Link>
                <Link to="/privacy" class="nav-link px-3" href="#">
                  Privacy Policy
                </Link>
                <Link to="/faq" class="nav-link" href="#">
                  FAQs
                </Link>
              </nav>
            </div>
            <div class="col-lg-3 col-md-12 col-12 d-lg-flex justify-content-end">
              <div>
                <a href="#" class="me-3">
                  <i class="bi bi-facebook text-dark"></i>
                </a>
                <a href="#" class="me-3">
                  <i class="bi bi-twitter text-dark"></i>
                </a>
                <a href="#" class="me-3">
                  <i class="bi bi-instagram text-dark"></i>
                </a>
                <a href="#">
                  <i class="bi bi-youtube text-dark"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
